import { adornmentTypeConstants } from "../../../../constants/constants";
import localize, { LocKeys } from "../../../../constants/localizations";

export const customAdjustmentConstants = {
	percentage: "percentage",
	time: "time",
	velocity: "velocity",
	pricePerSquare: "pricePerSquare",
	pricePerBuilding: "pricePerBuilding",
};

export const getCustomAdjustmentType = (constant) => {
	switch (constant) {
		case customAdjustmentConstants.percentage:
			return adornmentTypeConstants.PERCENTAGE;

		case customAdjustmentConstants.time:
			return adornmentTypeConstants.HOURS;

		case customAdjustmentConstants.velocity:
			return adornmentTypeConstants.SQUARE_METER_HOUR;

		case customAdjustmentConstants.pricePerSquare:
			return adornmentTypeConstants.EURO_METERS;

		case customAdjustmentConstants.pricePerBuilding:
			return adornmentTypeConstants.EURO;

		default:
			return null;
	}
};

export const getCustomAdjustmentTypeLabel = (constant) => {
	switch (constant) {
		case customAdjustmentConstants.percentage:
			return localize(LocKeys.PERCENTAGE);

		case customAdjustmentConstants.time:
			return localize(LocKeys.TIME);

		case customAdjustmentConstants.velocity:
			return localize(LocKeys.VELOCITY);

		case customAdjustmentConstants.pricePerSquare:
			return localize(LocKeys.PRICE_PER_SQUARE);

		case customAdjustmentConstants.pricePerBuilding:
			return localize(LocKeys.PRICE_PER_BUILDING);

		default:
			return null;
	}
};

export const typeOptions = [
	{
		label: localize(LocKeys.PERCENTAGE),
		value: customAdjustmentConstants.percentage,
	},
	{
		label: localize(LocKeys.TIME),
		value: customAdjustmentConstants.time,
	},
	{
		label: localize(LocKeys.VELOCITY),
		value: customAdjustmentConstants.velocity,
	},
];

/**
 * Options shown only for service-type manuals (isServiceType = true):
 * services are priced (per m2 or per building), not time-adjusted.
 */
export const serviceTypeOptions = [
	{
		label: localize(LocKeys.PRICE_PER_SQUARE),
		value: customAdjustmentConstants.pricePerSquare,
	},
	{
		label: localize(LocKeys.PRICE_PER_BUILDING),
		value: customAdjustmentConstants.pricePerBuilding,
	},
];

export const saveAdjustmentData = (data, type, value) => {
	data["timeAdjustment"] = null;
	data["percentageAdjustment"] = null;
	data["velocityAdjustment"] = null;
	data["pricePerSquare"] = null;
	data["pricePerBuilding"] = null;

	if (type === customAdjustmentConstants.time) {
		data["timeAdjustment"] = +value;
	} else if (type === customAdjustmentConstants.percentage) {
		data["percentageAdjustment"] = +value;
	} else if (type === customAdjustmentConstants.velocity) {
		data["velocityAdjustment"] = +value;
	} else if (type === customAdjustmentConstants.pricePerSquare) {
		data["pricePerSquare"] = +value;
	} else if (type === customAdjustmentConstants.pricePerBuilding) {
		data["pricePerBuilding"] = +value;
	}
};

/**
 * Filters the global input-format list down to only the formats that
 * actually appear in the row data, so the shared CustomHeader always
 * renders the same column count/order as the rows below it. Without this,
 * a global input format with no adjustment rows yet (e.g. newly added IFC)
 * makes the header wider than the data and wraps.
 */
export const getVisibleInputFormats = (inputFormats, data) => {
	if (!inputFormats || !data) return inputFormats;

	const visibleIds = new Set();
	data.valueSeq().forEach((item) => {
		const rowFormats = item.get("inputFormats");
		rowFormats &&
			rowFormats.forEach((inputFormat) =>
				visibleIds.add(`${inputFormat.get("inputFormatId")}`)
			);
	});

	return inputFormats.filter((format) => visibleIds.has(`${format.get("id")}`));
};

/**
 * Services pricing only ever prices primitive input formats (Image, CAD,
 * Point cloud) — review 2026-07-16 #6. IFC (and any other non-primitive
 * format) has no adjustment UI, so strip those entries from each row's
 * `inputFormats` before rendering. `getVisibleInputFormats` derives the
 * header purely from what's left on the rows, so this single pass also
 * drops the IFC header column for free — no separate header-side filter
 * needed. A null/missing `isPrimitiveFormat` flag counts as non-primitive.
 * Exports tables are untouched — they legitimately price every format.
 */
export const filterPrimitiveInputFormatRows = (data, inputFormats) => {
	if (!data || !inputFormats) return data;

	const primitiveIds = new Set(
		inputFormats
			.filter((format) => !!format.get("isPrimitiveFormat"))
			.map((format) => `${format.get("id")}`)
			.toArray()
	);

	return data.map((item) => {
		const rowFormats = item.get("inputFormats");
		return rowFormats
			? item.set(
					"inputFormats",
					rowFormats.filter((inputFormat) =>
						primitiveIds.has(`${inputFormat.get("inputFormatId")}`)
					)
				)
			: item;
	});
};

export const saveCustomAdjustmentData = (data, type, value) => {
	data["customTimeAdjustment"] = null;
	data["customPercentageAdjustment"] = null;
	data["customVelocityAdjustment"] = null;

	if (type === customAdjustmentConstants.time) {
		data["customTimeAdjustment"] = +value;
	} else if (type === customAdjustmentConstants.percentage) {
		data["customPercentageAdjustment"] = +value;
	} else if (type === customAdjustmentConstants.velocity) {
		data["customVelocityAdjustment"] = +value;
	} else {
		data["customTimeAdjustment"] = +value;
		// data["customPercentageAdjustment"] = null;
		// data["customVelocityAdjustment"] = null;
	}
};
